<template>
  <div class="in-lesson-course-ware">
    <LessonCourseware :class-type-id="classTypeId" :lesson-id="lessonId" />
  </div>
</template>
<script>

import LessonCourseware from '@/components/Courseware/LessonCourseware.vue'

export default {
  components: {
    LessonCourseware
  },
  props: {
    classTypeId: {
      type: Number,
      default: () => -1
    },
    lessonId: {
      type: Number,
      default: () => -1
    }
  },
  data() {
    return {
    }
  },
  created() {
  }
}
</script>
<style scoped lang="less">
@import '~@/static/css/base.less';
.in-lesson-course-ware {
  height: 100%;
}
</style>
